import { isTheLittleBraCompany } from 'utils/retailer';

export default function getButtonInfo() {
  return isTheLittleBraCompany() ? 'Continue' : 'Login';
}
